import React, { useEffect } from "react";
import Navbar from "../../component/navbar/Navbar";
import Footer from "../../component/footer";
import { usePrivacyPolicy } from "../../hooks/usePrivacyPolicy";
import loaderGif from "../../assets/learnlocalLoader.gif";

const TermsOfUse = () => {
  const { data, loading, error, fetchPrivacyPolicy } = usePrivacyPolicy();

  useEffect(() => {
    fetchPrivacyPolicy({ heading: "Parent/Legal Guardian Attestation" });
  }, [fetchPrivacyPolicy]);

  return (
    <>
      {/* <Navbar /> */}
      <div className="container mx-auto px-4 py-10 min-h-screen">
        <div className="space-y-6">
          <h2 className="text-3xl font-bold text-black mb-8 border-b pb-4">
            Terms of Use
          </h2>

          {loading && (
            <div className="flex flex-col items-center justify-center py-20">
              <img src={loaderGif} alt="Loading" className="w-20 h-20" />
              <p className="text-gray-500 mt-2">Loading Terms...</p>
            </div>
          )}

          {error && (
            <div className="text-red-500 text-center py-10">
              <p>{error}</p>
              <button
                onClick={() => fetchPrivacyPolicy({ heading: "Terms of Use" })}
                className="mt-4 text-secondaryText underline"
              >
                Try Again
              </button>
            </div>
          )}

          {!loading && !error && data && (
            <div
              className="privacy-content"
              dangerouslySetInnerHTML={{ __html: data.content }}
            />
          )}

          {!loading && !error && !data && (
            <p className="text-gray-500 text-center py-10">
              No content available.
            </p>
          )}
        </div>
      </div>
      {/* <Footer /> */}
    </>
  );
};

export default TermsOfUse;
